import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { COLORS } from '@elevair/shared';

interface MoreItemsBadgeProps {
  count: number;
  onClick: () => void;
  color?: 'primary' | 'error' | 'warning' | 'success' | 'info';
  label?: string;
}

const colorMap = {
  primary: COLORS.primary,
  error: '#d32f2f',
  warning: '#ed6c02',
  success: '#2e7d32',
  info: '#0288d1',
};

export const MoreItemsBadge: React.FC<MoreItemsBadgeProps> = ({
  count,
  onClick,
  color = 'primary',
  label,
}) => {
  const bgColor = colorMap[color];
  const tooltipText = label || `+${count} more. Click to view all`;

  return (
    <Tooltip title={tooltipText}>
      <Box
        onClick={onClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 32,
          height: 32,
          borderRadius: '50%',
          backgroundColor: bgColor,
          color: '#fff',
          cursor: 'pointer',
          transition: 'transform 0.2s, box-shadow 0.2s',
          boxShadow: 1,
          '&:hover': {
            transform: 'scale(1.1)',
            boxShadow: 3,
          },
        }}
      >
        <Typography variant="caption" fontWeight="bold" sx={{ fontSize: '0.75rem' }}>
          +{count}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default MoreItemsBadge;
